import React from "react";
export function FooterSection() {
  return <footer className="bg-navy-900 px-4 pb-32 pt-12 text-white/70 md:pb-16" data-id="element-216" data-mp="1pnw2q632cx0m">
      <div className="mx-auto max-w-3xl space-y-3 text-sm leading-relaxed" data-id="element-217" data-mp="3unbyjzzc1cyk">
        <h2 className="font-display text-base font-extrabold uppercase text-white" data-id="element-218" data-mp="2igq4u2x269d">Important educational disclaimer</h2>
        <p data-id="element-219" data-mp="7imadp6uwqhf">
          Shoulder Assessment Blueprint™ is an educational resource intended to support professional learning and the
          organization of shoulder assessment concepts.
        </p>
        <p data-id="element-220" data-mp="hepn1ozc47im">
          It does not guarantee diagnostic accuracy or clinical outcomes. It does not replace professional education,
          supervised clinical training, individualized patient assessment, professional judgment, current clinical
          guidelines, emergency procedures, or appropriate medical referral.
        </p>
        <p data-id="element-221" data-mp="v5b0uz9xlr9n">
          Clinical decisions must be made by appropriately qualified professionals within their scope of practice and
          in accordance with applicable laws, regulations, and professional standards.
        </p>
        <p data-id="element-222" data-mp="13b3znntnibmc">
          The educational cases are illustrative and should not be interpreted as individualized medical advice or
          definitive diagnostic protocols.
        </p>
        <p data-id="element-223" data-mp="ua5rctc6jhxy">
          Clinical examination procedures should be selected and interpreted in the context of the patient’s
          presentation, the available evidence, and the limitations of each assessment method.
        </p>
        <div className="border-t border-white/10 pt-5 text-center text-white/60" data-id="element-224" data-mp="1myl39700lk52">
          <p data-id="element-225" data-mp="1i7v102mvxxel">© 2026 Shoulder Assessment Blueprint™. All rights reserved.</p>
          <p data-id="element-226" data-mp="1i5ry4i0mw9sg">Created by Dr. Ryan Carter.</p>
        </div>
      </div>
    </footer>;
}